import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';
import { register } from 'swiper/element/bundle';

import { VERSION } from '@env/version';

import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.sentryEnabled) {
    Sentry.init({
        dsn: environment.sentryDsn,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        tracesSampleRate: 0.5,
        tracePropagationTargets: [environment.apiUrl],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: environment.environment,
        release: 'mst-fe@' + VERSION.version,
        beforeSend(event, hint) {
            if (hint?.originalException?.toString().includes('401')) {
                return null;
            }
            return event;
        },
    });

    Sentry.setTag('environment', environment.environment);
}

register();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
